import Highcharts from 'highcharts';

export const getDefaultSettings: (getScaledPxFn: (px: number) => number) => Highcharts.Options = (getScaledPxFn) => ({
    chart: {
        type: 'scatter',
        /* @ts-ignore */
        zoomType: 'xy',
        backgroundColor: 'transparent',
        marginBottom: getScaledPxFn(30),
        animation: false,
        resetZoomButton: {
            theme: {
                stroke: '0',
                fill: '#4FBBF8',
                r: getScaledPxFn(15),
                height: getScaledPxFn(15),
                style: {
                    color: 'black',
                },
                states: {
                    hover: {
                        fill: '#348ec2',
                    }
                }
            }
        },
        events: {
            render: (event: any) => {
                const xAxis = event?.target.axes[0];
                const yAxis = event?.target.axes[1];
                const xMin = xAxis?.min ?? 0;
                const xMax = xAxis?.max ?? 100;
                const yMin = yAxis?.min ?? 0;
                const yMax = yAxis?.max ?? 100;
                (event?.target?.series as any[]).forEach(set => {
                    set?.points.forEach((point: any) => {
                        if (point?.x >= xMin && point?.x <= xMax && point?.y >= yMin && point?.y <= yMax) {
                            point?.graphic?.element?.setAttribute(
                                'data-tooltip-id',
                                `scatter-chart-item-${point.id}`
                            );
                        } else {
                            point?.graphic?.element?.removeAttribute('data-tooltip-id');
                        }
                    });
                });
            }
        }
    },
    title: { text: '' },
    subtitle: { text: '' },
    xAxis: {
        visible: true,
        // min: 0,
        // max: 100,
        showLastLabel: true,
        gridLineWidth: 0,
        minorGridLineWidth: 0,

        title: { text: '' },
        labels: {
            enabled: true,
            style: {
                color: '#B9BFC7'
            },
        },

        lineWidth: 0,
        tickLength: 0
    },
    yAxis: {
        visible: true,
        // min: 0,
        // max: 100,
        showLastLabel: true,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        title: { text: '' },
        lineWidth: 0,
        tickLength: 0,
        startOnTick: false,
        endOnTick: false,

        labels: {
            style: {
                color: '#B9BFC7'
            },
        },

    },
    legend: { enabled: false },
    tooltip: { enabled: false, },
    plotOptions: {
        scatter: {
            turboThreshold: 0,
            animation: false,
            marker: {
                radius: getScaledPxFn(3),
                states: {
                    hover: {
                        enabled: true,
                        lineColor: "#ffffff",
                        lineWidthPlus: getScaledPxFn(1),
                    },
                    select: {
                        enabled: true,
                        lineColor: undefined,
                        lineWidth: getScaledPxFn(1),
                        radius: getScaledPxFn(4)
                    }
                },
            },
        },
        series: {
            stickyTracking: false,
            turboThreshold: 0,
            cursor: 'pointer',
            states: {
                inactive: {
                    enabled: false,
                }
            }
        },
    },
    credits: {
        enabled: false
    },

});